<template>
  <div class="progress-bar" ref="progressBar">
    <p class="sr-only" aria-live="polite" aria-atomic="true">
      Progress value is
      <span class="progress-bar__aria-value">{{ barValue }}%</span>
    </p>
    <span class="progress-bar__value" aria-hidden="true">{{ displayedValue }}%</span>
    <div class="progress-bar__bg" aria-hidden="true">
      <div class="progress-bar__fill" :style="{ width: displayedValue + '%' }"></div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  props: {
    barValue: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const progressBar = ref(null);
    const displayedValue = ref(0);

    const animateProgressBar = () => {
      let currentProgress = 0;
      const animationInterval = setInterval(() => {
        currentProgress += 1;
        displayedValue.value = currentProgress;
        if (currentProgress >= props.barValue) {
          clearInterval(animationInterval);
        }
      }, 10);
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateProgressBar();
          observer.unobserve(entry.target);
        }
      });
    });

    onMounted(() => {
      observer.observe(progressBar.value);
    });

    return {
      progressBar,
      displayedValue
    };
  }
};
</script>